// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uitk-scrollable{block-size:100%}.uitk-scrollable-horizontal{display:flex;overflow-x:auto}.uitk-scrollable-vertical{overflow-y:auto}", ""]);
// Exports
module.exports = exports;
